export default {
  learnMore: {
    id: 'visible_by_verizon_carousel_header_learn_more',
    defaultMessage: 'Learn more',
  },
}
